import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import ChangePassword from "../../pages/ChangePassword/ChangePassword.jsx";
import ChangeProfile from "../../pages/ChangeProfile/ChangeProfile.jsx";
import AddDiscount from "../../pages/Discounts/AddDiscount.jsx";
import Discounts from "../../pages/Discounts/Discounts.jsx";
import Error from "../../pages/Error/Error.jsx";
import Logout from "../../pages/Logout/Logout.jsx";
import Main from "../../pages/Main/Main.jsx";
import AddMaterial from "../../pages/Materials/AddMaterial.jsx";
import MaterialDetails from "../../pages/Materials/MaterialDetails.jsx";
import Materials from "../../pages/Materials/Materials.jsx";
import Installments from "../../pages/Orders/Installments.jsx";
import OrderDetails from "../../pages/Orders/OrderDetails.jsx";
import OrderStatus from "../../pages/Orders/OrderStatus.jsx";
import OrderTicketContext from "../../pages/Orders/OrderTicketContext.jsx";
import Orders from "../../pages/Orders/Orders.jsx";
import Services from "../../pages/Orders/Services.jsx";
import Payments from "../../pages/Payments/Payments.jsx";
import AddProperty from "../../pages/Properties/AddProperty.jsx";
import Properties from "../../pages/Properties/Properties.jsx";
import EditService from "../../pages/ServicesPage/EditService.jsx";
import ServiceDetails from "../../pages/ServicesPage/ServiceDetails.jsx";
import ServiceTicketContext from "../../pages/ServicesPage/ServiceTicketContext.jsx";
import ServicesPage from "../../pages/ServicesPage/ServicesPage.jsx";
import UserDetails from "../../pages/ServicesPage/UserDetails.jsx";
import ShowProfile from "../../pages/ShowProfile/ShowProfile.jsx";
import AddTicket from "../../pages/Tickets/AddTicket.jsx";
import Context from "../../pages/Tickets/Context.jsx";
import EditTicketRoles from "../../pages/Tickets/EditTicketRoles.jsx";
import EditTicketStatus from "../../pages/Tickets/EditTicketStatus.jsx";
import Tickets from "../../pages/Tickets/Tickets.jsx";
import AddUser from "../../pages/Users/AddUser.jsx";
import UserAddress from "../../pages/Users/UserAddresses.jsx";
import UserCompany from "../../pages/Users/UserCompanies.jsx";
import Users from "../../pages/Users/Users.jsx";
import Footer from "./Footer/Footer.jsx";
import OrderedServicePage from "../../pages/ServicesPage/OrderedServicePage.jsx";
import ContractorServicePage from "../../pages/ServicesPage/ContractorServicePage.jsx";
import FinancialPage from "../../pages/Financial/FinancialPage.jsx";
import ManageContractorServicePage from "../../pages/ServicesPage/ManageContractorServicePage.jsx";
import QualityControlPage from "../../pages/ServicesPage/QualityControlPage.jsx";
import WithdrawalRequestPage from "../../pages/Financial/WithdrawalRequestPage.jsx";

const Content = () => {
  const navigate = useNavigate();
  const { userRole } = localStorage.getItem("cncToken")
    ? JSON.parse(localStorage.getItem("cncToken"))
    : navigate("/auth/login");

  return (
    <div
      id="div-content"
      className="div-content fixed top-16 left-0 
            w-full overflow-auto"
    >
      <div
        className="w-full main-container
            py-10 px-6 sm:px-0 xl:px-8"
      >
        <main
          className="custom-box-shadow bg-color container mx-auto 
                rounded-lg py-8 px-4 md:px-8"
        >
          <Routes>
            <Route path="/" element={<Main />} />
            {(userRole.id === 1 || userRole.id === 3 || userRole.id === 4) && (
              <Route path="/users" element={<Users />}>
                <Route path="add-user" element={<AddUser />} />
                <Route path="address" element={<UserAddress />} />
                <Route path="company" element={<UserCompany />} />
              </Route>
            )}
            {(userRole.id === 1 || userRole.id === 7) && (
              <Route path="/services" element={<ServicesPage />}>
                <Route path="user" element={<UserDetails />} />
                <Route path="service" element={<ServiceDetails />} />
                <Route path="edit-service" element={<EditService />} />
                <Route path="ticket" element={<ServiceTicketContext />} />
              </Route>
            )}
            {(userRole.id === 1 || userRole.id === 4) && (
              <Route path="/orders" element={<Orders />}>
                <Route path="order" element={<OrderDetails />} />
                <Route path="user" element={<UserDetails />} />
                <Route path="order-status" element={<OrderStatus />} />
                <Route path="ticket" element={<OrderTicketContext />} />
                <Route path="services" element={<Services />}>
                  <Route path="user" element={<UserDetails />} />
                  <Route path="service" element={<ServiceDetails />} />
                </Route>
                <Route path="installments" element={<Installments />} />
              </Route>
            )}
            {(userRole.id === 1) && (
              <Route path="/payments" element={<Payments />}>
                <Route path="order" element={<OrderDetails />} />
              </Route>
            )}
            {(userRole.id === 2) && (
              <Route path="/receive-services" element={<OrderedServicePage />}>
              </Route>
            )}
            {(userRole.id === 2) && (
              <Route path="/financial" element={<FinancialPage />}>
              </Route>
            )}
            {(userRole.id === 1 || userRole.id === 2 || userRole.id === 6) && (
              <Route path="/my-services" element={<ContractorServicePage />}>
              </Route>
            )}
            {(userRole.id === 1 || userRole.id === 4) && (
              <Route path="/contractor-settlement" element={<WithdrawalRequestPage />}>
              </Route>
            )}
            {(userRole.id === 6 || userRole.id === 1) && (
              <Route path="/manage-contractor" element={<ManageContractorServicePage />}>
              </Route>
            )}
            {(userRole.id === 1 || userRole.id === 7) && (
              <Route path="/quality-control" element={<QualityControlPage />}>
              </Route>
            )}
            <Route path="/tickets" element={<Tickets />}>
              <Route path="add-ticket" element={<AddTicket />} />
              <Route path="edit-ticket-roles" element={<EditTicketRoles />} />
              <Route path="edit-ticket-status" element={<EditTicketStatus />} />
              <Route path="context" element={<Context />} />
            </Route>
            {(userRole.id === 1) && (
              <Route path="/discounts" element={<Discounts />}>
                <Route path="add-discount" element={<AddDiscount />} />
              </Route>
            )}
            {userRole.id === 1 && (
              <Route path="/properties" element={<Properties />}>
                <Route path="add-property" element={<AddProperty />} />
              </Route>
            )}
            {userRole.id === 1 && (
              <Route path="/materials" element={<Materials />}>
                <Route path="add-material" element={<AddMaterial />} />
                <Route path="material" element={<MaterialDetails />} />
              </Route>
            )}
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/show-profile" element={<ShowProfile />} />
            {/* <Route path="/change-profile" element={<ChangeProfile />} /> */}
            <Route path="/logout" element={<Logout />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Content;
